import React, { useEffect, useRef, useState } from 'react';
import Icon from '../shared/Icon';
import { TAB_STATE } from './tabsUtils';

/**
 * The menu on the active tab. An owner can rename, share, move and delete; someone a
 * tab is shared with can only move it in their own bar or hide it. Move left / right
 * are here as well as drag-and-drop so the order can be changed from the keyboard.
 */
function DashboardTabMenu({ tab, index, count, canShare, canDelete, onRename, onShare, onMove, onDelete, onHide }) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    if (!open) return undefined;
    const onDocClick = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener('mousedown', onDocClick);
    return () => document.removeEventListener('mousedown', onDocClick);
  }, [open]);

  const run = (fn) => () => {
    setOpen(false);
    fn();
  };
  const shared = tab.state === TAB_STATE.SHARED_BY_YOU;

  return (
    <span className="dtb-menu-wrap" ref={ref}>
      <button
        type="button"
        className="dtb-menu-btn"
        aria-label={`Actions for ${tab.name}`}
        aria-haspopup="menu"
        aria-expanded={open}
        onClick={() => setOpen((o) => !o)}
      >
        <Icon name="more_vert" />
      </button>
      {open && (
        <div className="dtb-dropdown" role="menu">
          {tab.is_own && <button type="button" role="menuitem" onClick={run(onRename)}>Rename</button>}
          {tab.is_own && (canShare || shared) && (
            <button type="button" role="menuitem" onClick={run(() => onShare(!shared))}>
              {shared ? 'Stop sharing' : 'Share with organization'}
            </button>
          )}
          <button type="button" role="menuitem" disabled={index === 0} onClick={run(() => onMove(index - 1))}>
            Move left
          </button>
          <button type="button" role="menuitem" disabled={index >= count - 1} onClick={run(() => onMove(index + 1))}>
            Move right
          </button>
          {!tab.is_own && <button type="button" role="menuitem" onClick={run(onHide)}>Hide tab</button>}
          {tab.is_own && (
            <button
              type="button"
              role="menuitem"
              className="dtb-dropdown-danger"
              disabled={!canDelete}
              title={canDelete ? undefined : 'Your last tab cannot be deleted'}
              onClick={run(onDelete)}
            >
              Delete tab
            </button>
          )}
        </div>
      )}
    </span>
  );
}

export default DashboardTabMenu;
